import { render, staticRenderFns } from "./logo-uploader.vue?vue&type=template&id=472b710a&scoped=true&"
import script from "./logo-uploader.vue?vue&type=script&lang=js&"
export * from "./logo-uploader.vue?vue&type=script&lang=js&"
import style0 from "./logo-uploader.vue?vue&type=style&index=0&id=472b710a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b710a",
  null
  
)

export default component.exports